import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { WholesalerProvider } from "./context/WholesalerContext"; // Phase 5: tenant context
import { ToastProvider } from "./context/ToastContext";
import { ProductsProvider } from "./context/ProductsContext";       // shared product listener
import { UpdateVersionProvider } from "./context/UpdateVersionContext.js"; // lightweight version watcher
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        {/*
          WholesalerProvider is mounted inside AuthProvider so wholesalerId
          from token claims is always resolved before WholesalerContext
          starts its Firestore listener. App.js calls useWholesaler() and
          requires this provider to be present in the tree.
        */}
        <WholesalerProvider>
          <ToastProvider>
            <ProductsProvider>
              {/*
                UpdateVersionProvider sits here so ALL retailer pages share
                exactly ONE onSnapshot listener on the per-tenant version doc
                (wholesalers/{wholesalerId}/updateVersions/current).
                This replaces 3 heavy per-user collection listeners (orders,
                returns, rewards) with a single 1-field document watch,
                scoped so a change in one tenant never signals another's clients.
              */}
              <UpdateVersionProvider>
                <CartProvider>
                  <App />
                </CartProvider>
              </UpdateVersionProvider>
            </ProductsProvider>
          </ToastProvider>
        </WholesalerProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for PWA (offline support + home screen install)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // L-7 fix: cache invalidation strategy.
        // When a new SW version finishes installing, tell it to activate
        // immediately instead of waiting for all tabs to close.
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && registration.waiting) {
              registration.waiting.postMessage("SKIP_WAITING");
            }
          });
        });

        // If a SW is already waiting at registration time, activate it too.
        if (registration.waiting) {
          registration.waiting.postMessage("SKIP_WAITING");
        }
      })
      .catch((err) => console.error("SW registration failed:", err));

    // Once the new worker takes control, reload so the user gets the
    // freshly-deployed JS/CSS bundle instead of stale cached assets.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}